/**
 * Constantes des plans UNIQUE SaaS — côté frontend.
 * Miroir de ai-backend/models/plans.py.
 */

export type PlanKey = 'free' | 'essential' | 'pro';

export const PLAN_PRICES: Record<PlanKey, number> = {
  free:      0,
  essential: 10_000, // FCFA / mois
  pro:       15_000, // FCFA / mois
};

export const PLAN_LABELS: Record<PlanKey, string> = {
  free:      'Gratuit',
  essential: 'Essentiel',
  pro:       'Pro',
};

export interface PlanLimits {
  maxTasks:          number;  // -1 = illimité
  aiBriefingPerDay:  number;  // -1 = illimité
  aiDraftsPerMonth:  number;  // -1 = illimité, 0 = bloqué
  focusMode:         boolean;
  commHubActions:    boolean;
  analytics30Days:   boolean;
  pdfExport:         boolean;
  escalations:       boolean;
  smartSave:         boolean;
}

export const PLAN_LIMITS: Record<PlanKey, PlanLimits> = {
  free: {
    maxTasks:         10,
    aiBriefingPerDay: 1,
    aiDraftsPerMonth: 0,
    focusMode:        false,
    commHubActions:   false,
    analytics30Days:  false,
    pdfExport:        false,
    escalations:      false,
    smartSave:        false,
  },
  essential: {
    maxTasks:         -1,
    aiBriefingPerDay: 5,
    aiDraftsPerMonth: 20,
    focusMode:        true,
    commHubActions:   true,
    analytics30Days:  true,
    pdfExport:        true,
    escalations:      false,
    smartSave:        true,
  },
  pro: {
    maxTasks:         -1,
    aiBriefingPerDay: -1,
    aiDraftsPerMonth: -1,
    focusMode:        true,
    commHubActions:   true,
    analytics30Days:  true,
    pdfExport:        true,
    escalations:      true,
    smartSave:        true,
  },
};

/** Calcule le prix total pour un plan + durée, avec remise fidélité. */
export function computePrice(plan: PlanKey, months: number): number {
  const base = PLAN_PRICES[plan];
  if (base === 0) return 0;
  let discount = 0;
  if (months >= 24) discount = 0.25;
  else if (months >= 12) discount = 0.15;
  else if (months >= 6) discount = 0.10;
  else if (months >= 3) discount = 0.05;
  return Math.round(base * months * (1 - discount));
}
